import { Component, Input, effect, inject } from '@angular/core';
import { SharedSignalsService } from '../../services/shared-signals.service';
import { TranslationService } from '../../services/translation.service';

export interface InstalmentItem {
  label: string;
  amount: number;
  lightImgUrl: string;
  darkImgUrl: string;
}

@Component({
  selector: 'taly-instalments',
  templateUrl: './instalments.component.html',
  styleUrls: ['./instalments.component.scss'],
  standalone: false,
})
export class InstalmentsComponent {
  public translationService = inject(TranslationService);
  transferSignal = inject(SharedSignalsService);

  sliderAmount: InstalmentItem[] = [];

  orderAmount: any;

  @Input() isLightTheam: boolean;

  @Input()
  set amounts(value: any) {
    this.orderAmount = value;
    this.setSliderAmount();
  }

  textDirection: string;

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
      setTimeout(() => {
        this.setSliderAmount();
      }, 10);
    });
  }

  setSliderAmount() {
    this.sliderAmount = [
      {
        label: this.translationService.getLabelValue('LEARN_MORE_PAGE.TODAY'),
        amount: this.orderAmount / 4,
        lightImgUrl: 'assets/images/Instalment-0.svg',
        darkImgUrl: 'assets/images/Instalments-0.svg',
      },
      {
        label: this.translationService.getLabelValue('LEARN_MORE_PAGE.30_DAY'),
        amount: this.orderAmount / 4,
        darkImgUrl: 'assets/images/plan-icon-2.svg',
        lightImgUrl: 'assets/images/dark-icon-2.svg',
      },
      {
        label: this.translationService.getLabelValue('LEARN_MORE_PAGE.60_DAY'),
        amount: this.orderAmount / 4,
        darkImgUrl: 'assets/images/plan-icon-3.svg',
        lightImgUrl: 'assets/images/dark-icon-3.svg',
      },
      {
        label: this.translationService.getLabelValue('LEARN_MORE_PAGE.90_DAY'),
        amount: this.orderAmount / 4,
        darkImgUrl: 'assets/images/plan-icon-4.svg',
        lightImgUrl: 'assets/images/dark-icon-4.svg',
      },
    ];
  }
}
